//handles redux exhibitor state
import {createSlice} from '@reduxjs/toolkit';

const initialStateValue = ''

export const loginPasswordSlice = createSlice({
    name:"loginPassword",
    initialState:{value:initialStateValue},
    reducers:{
        rxLoginPassword:(state,action)=>{
            state.value = action.payload
        },
    }
})

export const {rxLoginPassword} = loginPasswordSlice.actions

export default loginPasswordSlice.reducer;
